import { mapState } from 'ui.vue3.pinia';
import { CatalogCard, vplSiteStore } from 'vpl.tas';

export const BlogRecommendedProducts = {
    components: {
        CatalogCard
    },
    props: {
        structKey: [String, Number]
    },
    computed: {
        ...mapState(vplSiteStore, ['struct']),
        recommendation() {
            const block = this.struct[this.structKey];

            return block && block.componentData
                ? block.componentData
                : {};
        },
        section() {
            return this.recommendation.BLOG_SECTION || {};
        },
        items() {
            return Object.values(this.recommendation.ITEMS || {})
                .filter(item => item);
        }
    },
    template: `
<section v-if="items.length && section.NAME" class="blog__recommend">
    <div class="container">
        <div class="blog__recommend-heading">
            <h2 class="blog__recommend-title">
                Интересное из раздела
                <span>{{ section.NAME }}</span>
            </h2>
            <a :href="section.URL" class="btn btn--border blog__recommend-all">
                Все {{ section.NAME }}
                <svg class="icon icon-arrow-next">
                    <use xlink:href="#icon-arrow-next"></use>
                </svg>
            </a>
        </div>
        <div class="blog__recommend-grid">
            <CatalogCard
                v-for="item in items"
                :key="item.ID"
                :item="item"
                :struct-key="structKey"
            />
        </div>
    </div>
</section>
    `
};
